import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { InvalidFeedback } from "../styledComponents/AccountPage";
import {
  StyledModalBody,
  StyledModal,
  StyledModalFooter,
  ModalLogoWrapper,
  ModalLogoYET,
  ModalLogoPUB,
  ModalLogoABC,
  ModalLogoPLC,
  ModalLogoFUN,
  ModalLogoCAC,
  ModalLogoHYC,
  ModalLogoYAK,
} from "../styledComponents/StyledModals";
import {
  StyledButton,
  StyledInput,
} from "../styledComponents/CommonStyledComponents";
import { StyledRegisterFormGroup } from "../styledComponents/StyledSignupLogin";

export const SetRealityCheckDialog = ({
  showModal,
  handleProceed,
  errors,
  skin,
}) => {
  const { t } = useTranslation("");

  const [realityCheckValue, setRealityCheckValue] = useState(null);

  return (
    <StyledModal isOpen={showModal}>
      {skin !== "qbc" && (
        <ModalLogoWrapper>
          {skin === "plc" && <ModalLogoPLC />}
          {skin === "abc" && <ModalLogoABC />}
          {skin === "pub" && <ModalLogoPUB />}
          {skin === "yet" && <ModalLogoYET />}
          {skin === "fun" && <ModalLogoFUN />}
          {skin === "cac" && <ModalLogoCAC />}
          {skin === "hyc" && <ModalLogoHYC />}
          {skin === "yak" && <ModalLogoYAK />}
        </ModalLogoWrapper>
      )}
      <StyledModalBody>
        <h3>{t("label_set_reality_check_title")}</h3>
        <div>{t("label_set_reality_check_text")}</div>
      </StyledModalBody>
      <StyledModalBody>
        {" "}
        <StyledRegisterFormGroup step>
          <label>{t("label_minutes")}</label>
          <StyledInput
            inputLg
            realityCheck={errors.realityCheck}
            type="number"
            min="15"
            step="1"
            max="60"
            value={realityCheckValue}
            name="realityCheck"
            onChange={(e) => setRealityCheckValue(e.target.value)}
          />
          {errors.realityCheck && (
            <InvalidFeedback>{t(errors.realityCheck)}</InvalidFeedback>
          )}
        </StyledRegisterFormGroup>
      </StyledModalBody>

      <StyledModalFooter position>
        <StyledButton
          banktransfer
          pub={skin === "pub"}
          type="submit"
          onClick={() => handleProceed(realityCheckValue)}
        >
          {t("label_ok")}
        </StyledButton>
      </StyledModalFooter>
    </StyledModal>
  );
};
